import { Description, FindInPage } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAppointmentsCalendar,
  getAvailableDocumentsToAdd,
  getClinicHistoryHTML,
  getDocuments,
  getPrePrintedForms,
} from "../../../../../actions/accidentDashboard";
import { CODIGO_AUDITORIA, registrarAccionFrontend } from "../../../../../actions/audit";
import { postSignForm, setChangeDocument } from "../../../../../actions/forms";
import {
  openEditForm,
  setFormsDocumentList
} from "../../../../../actions/formsState";
import snackbarUtils from "../../../../../utils/snackbarUtils";
import { parseHTMLToReact } from "../../../../../utils/util";
import NullifyFormContainer from "../../../../commons/cancelForm/NullifyFormContainer";
import PrintAndDownloadDialog from "../../../../commons/dialog/PrintAndDownloadDialog";
import ConfirmDialog from "../../../../commons/dialog/confirmDialog";
import { formBehaviourEnum } from "../../../../commons/enum/formEnums";
import { StyledFlex } from "../../../../styled/flex";
import CardTitle from "../cardTitle";
import AccidentDocumentsCards from "./accidentDocumentsCards";
import ErroresConectividadDialog from "./errorDialog/ErroresConectividadDialog";
import SignForm from "./sign/signForm";

const AccidentDocuments = ({
  idSiniestro, idArt
}) => {
  const dispatch = useDispatch();
  const documents = useSelector((state) => state.accidentDashboard.documents);
  const accident = useSelector((state) => state.accidentDashboard.accident);
  const clinicHistoryHTML = useSelector(
    (state) => state.accidentDashboard.clinicHistoryHTML,
  );
  const [selectedDocument, setSelectedDocument] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [accionImpresion, setAccionImpresion] = useState(null);

  const [openSignForm, setOpenSignForm] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [openNullifyForm, setOpenNullifyForm] = useState(false);
  const [idForm, setIdForm] = useState(null);
  const [openErroresConectividadDialog, setOpenErroresConectividadDialog] =
    useState(false);

  useEffect(() => {
    dispatch(getDocuments(accident.idSiniestro, accident.mlCloudCoreArtId));
  }, []);

  useEffect(() => {
    if (!documents.isFetching && !documents.error) {
      dispatch(setFormsDocumentList(documents.data));
    }
  }, [documents.isFetching, documents.error, documents.data]);

  const handleOpenDetail = (document, error = {}) => {
    dispatch(setFormsDocumentList(documents.data));
    dispatch(
      openEditForm(
        document.comportamiento,
        formBehaviourEnum.MODIFY_ACCIDENT_DOCUMENT,
        {
          nroFormulario: document.nroFormulario,
          documento: accident.documento,
        },
        {},
      ),
    );
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setAccionImpresion(null);
  };

  const abrirVistaPrevia = (titulo, accion) => {
    setModalTitle(titulo);
    setAccionImpresion(accion);
    setOpenModal(true);
  };

  const generateClinicHistoryHTML = () => {
    abrirVistaPrevia("Historia Clínica", { code: CODIGO_AUDITORIA.DESCARGA_HISTORIA_CLINICA });
    dispatch(
      getClinicHistoryHTML({
        accidentId: accident.idSiniestro,
        WRIId: accident.mlCloudCoreArtId,
      }),
    );
  };

  const generateClinicHistoryHTMLFpa = () => {
    abrirVistaPrevia("Pedidos de Autorización", {
      code: CODIGO_AUDITORIA.IMPRIMIR_FPA,
      requestInput: "Impresión de todos los pedidos de autorización",
    });
    dispatch(
      getClinicHistoryHTML({
        accidentId: accident.idSiniestro,
        WRIId: accident.mlCloudCoreArtId,
        formType: "Fpa",
      }),
    );
  };

  const generateSpecificFpaHTML = (document) => {
    abrirVistaPrevia(`FPA - ${document.nombreFormulario}`, {
      code: CODIGO_AUDITORIA.IMPRIMIR_FPA,
      requestInput: `formulario ${document.nroFormulario}`,
    });
    dispatch(
      getClinicHistoryHTML({
        accidentId: accident.idSiniestro,
        WRIId: accident.mlCloudCoreArtId,
        formType: "Fpa",
        formId: document.nroFormulario,
      }),
    );
  };

  const handleBeforePrint = () => {
    if (accionImpresion) {
      dispatch(registrarAccionFrontend({
        idArt: accident.mlCloudCoreArtId,
        code: accionImpresion.code,
        siniestro: accident.idSiniestro,
        numeroDocumento: accident.documento,
        requestInput: accionImpresion.requestInput,
      }));
    }
    return Promise.resolve(true);
  };

  const handleOpenDetailFromError = (document, error) => {
    dispatch(
      openEditForm(
        document.comportamiento,
        formBehaviourEnum.ERROR_DIALOG,
        {
          nroFormulario: document.nroFormulario,
          idRespError: error.idRespError,
          documento: accident.documento,
        },
        {},
      ),
    );
  };

  const handleOpenSignForm = (document) => {
    setSelectedDocument(document);
    setOpenSignForm(true);
  };

  const handleOpenConfirmDialog = () => {
    setConfirmDialogOpen(true);
  };
  const handleCloseErroresConectividad = () => {
    setOpenErroresConectividadDialog(false);
  };
  const handleCloseSignForm = () => {
    setSelectedDocument({});
    setOpenSignForm(false);
    handleCloseConfirmDialog();
  };

  const handleCloseConfirmDialog = () => {
    setConfirmDialogOpen(false);
  };

  const handleOpenErroresConectividad = (document) => {
    setSelectedDocument(document);
    setOpenErroresConectividadDialog(true);
  };
  const handleSubmitSignForm = (values) => {
    const form = {
      ...values,
      marcaFirmado: values.marcaFirmado === "Si" ? true : false,
      nroFormulario: selectedDocument.nroFormulario,
      siniestro: accident.idSiniestro,
    };

    dispatch(postSignForm(form)).then(() => {
      snackbarUtils.success("Firma enviada correctamente");
      handleCloseSignForm();
      dispatch(getDocuments(accident.idSiniestro, accident.mlCloudCoreArtId));
    });
  };

  const icons = [
    {
      Icon: FindInPage,
      tooltip: "Imprimir FPA",
      onClick: generateClinicHistoryHTMLFpa,
      disabled: false,
    },
    {
      Icon: Description,
      tooltip: "Emitir H.C.",
      onClick: generateClinicHistoryHTML,
      disabled: false,
    },
  ];

  return (
    <>
      <StyledFlex.ColumnContainer>
        <CardTitle
          title="DOCUMENTOS DEL SINIESTRO"
          color="primary"
          icons={icons}
        />
        <AccidentDocumentsCards
          data={documents.data}
          loading={documents.isFetching}
          handleOpenDetail={handleOpenDetail}
          handleOpenSign={handleOpenSignForm}
          handleOpenNullifyForm={(idForm) => {
            setOpenNullifyForm(true)
            setIdForm(idForm)
          }}
          setOpenErroresConectividadDialog={handleOpenErroresConectividad}
          handlePrintSpecificFpa={generateSpecificFpaHTML}
        />

        <PrintAndDownloadDialog
          maxWidth="lg"
          openModal={openModal}
          handleCloseModal={handleCloseModal}
          childComponent={
            <React.Fragment>
              {parseHTMLToReact(clinicHistoryHTML.data)}
            </React.Fragment>
          }
          loading={clinicHistoryHTML.isFetching || !openModal}
          title={modalTitle}
          showDownloadButton={false}
          onBeforePrint={handleBeforePrint}
          reactToPrintProps={{ suppressErrors: true }}
        />
        <SignForm
          open={openSignForm}
          handleConfirmClose={handleOpenConfirmDialog}
          handleClose={handleCloseSignForm}
          handleSubmit={handleSubmitSignForm}
          document={selectedDocument}
        />
      </StyledFlex.ColumnContainer>
      <div>
        <ConfirmDialog
          open={confirmDialogOpen}
          handleClose={handleCloseConfirmDialog}
          handleConfirm={handleCloseSignForm}
          title="CERRAR VENTANA"
          text="¿Está seguro que desea cancelar esta operación? En caso de aceptar, se perderá la información ingresada"
        />
      </div>
      <ErroresConectividadDialog
        setChangeDocument={setChangeDocument}
        open={openErroresConectividadDialog}
        handleClose={handleCloseErroresConectividad}
        selectedDocument={selectedDocument}
        handleOpenDetail={handleOpenDetailFromError}
        handleCloseErroresConectividad={handleCloseErroresConectividad}
      />
      <NullifyFormContainer
        open={openNullifyForm}
        handleClose={() => setOpenNullifyForm(false)}
        idArt={idArt}
        idForm={idForm}
        idSiniestro={idSiniestro}
        callback={() => {
          dispatch(getAvailableDocumentsToAdd(accident.idSiniestro, accident.mlCloudCoreArtId));
          dispatch(getDocuments(accident.idSiniestro, accident.mlCloudCoreArtId));
          dispatch(getPrePrintedForms(accident.mlCloudCoreArtId, accident.idSiniestro))
          dispatch(getAppointmentsCalendar(accident.idSiniestro, accident.mlCloudCoreArtId))
        }}
      />
    </>
  );
};

export default AccidentDocuments;
